<template>
    <carousel :perPage=1>
        <slide class="has-text-centered">
            <img src="../../assets/images/trash/6121038_2.jpg" />
        </slide>
        <slide class="has-text-centered">
            <img src="../../assets/images/trash/6121038_3.jpg" />
        </slide>
        <slide class="has-text-centered">
            <img src="../../assets/images/trash/lenovo-ideapad-120s-14iap-81a5_1.jpg" />
        </slide>
        <slide class="has-text-centered">
            <img src="../../assets/images/trash/l_10174627_004.jpg" />
        </slide>
    </carousel>
</template>
<script>
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        components: {
            Carousel,
            Slide
        },
        name: "Slider"
    }
</script>
<style scoped>
</style>